import React from 'react';
import styled from 'styled-components';

interface FormGroupProps {
  children: React.ReactNode;
  className?: string;
}

interface FormLabelProps {
  htmlFor?: string;
  required?: boolean;
  children: React.ReactNode;
}

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

interface FormSelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  children: React.ReactNode;
}

interface FormRowProps {
  children: React.ReactNode;
}

export const FormGroup: React.FC<FormGroupProps> = ({
  children,
  className
}) => <Group className={className}>{children}</Group>;

export const FormLabel: React.FC<FormLabelProps> = ({
  htmlFor,
  required,
  children
}) => (
  <Label htmlFor={htmlFor}>
    {children}
    {required && <Req>*</Req>}
  </Label>
);

export const FormInput: React.FC<FormInputProps> = (props) => (
  <Input {...props} />
);

export const FormSelect: React.FC<FormSelectProps> = ({
  children,
  ...props
}) => <Select {...props}>{children}</Select>;

export const FormRow: React.FC<FormRowProps> = ({ children }) => (
  <Row>{children}</Row>
);

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`;

const Label = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: var(--ink);
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

const Req = styled.span`
  color: var(--crimson);
  margin-left: 2px;
`;

const Input = styled.input`
  padding: 9px 12px;
  border: 1px solid var(--line);
  border-radius: 7px;
  font-size: 14px;
  font-family: var(--font-sans);
  background: var(--white);
  color: var(--ink);
  transition: border-color 0.15s;

  &:focus {
    outline: none;
    border-color: var(--terracotta);
  }

  &::placeholder {
    color: var(--ink-faint);
  }
`;

const Select = styled.select`
  padding: 9px 12px;
  border: 1px solid var(--line);
  border-radius: 7px;
  font-size: 14px;
  font-family: var(--font-sans);
  background: var(--white);
  color: var(--ink);
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: var(--terracotta);
  }
`;

const Row = styled.div`
  display: flex;
  gap: 12px;
`;
